import { render, staticRenderFns } from "./CampaignLabel.vue?vue&type=template&id=9de82496&"
import script from "./CampaignLabel.vue?vue&type=script&lang=ts&"
export * from "./CampaignLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports